// @ts-check

/** @file Defines the local Task shell and associations. */

import TaskBase from "../model-bases/task.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Task row in the local application replica. */
const TaskModel = projectReplicaModel(TaskBase)

export default TaskModel

TaskModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
TaskModel.belongsTo("parent", {className: "Task", foreignKey: "parent_id"})
TaskModel.belongsTo("taskType")
TaskModel.hasMany("children", {className: "Task", foreignKey: "parent_id"})
TaskModel.hasMany("comments", (scope) => scope.where({resourceType: "Task"}), {className: "Comment", foreignKey: "resource_id", polymorphic: true})
TaskModel.hasMany("taskAssignedUsers")
TaskModel.hasMany("taskBoards")
TaskModel.hasMany("timelogs")
